import { useNavigate } from "react-router-dom";

const BackButton = ({ to }) => {
    const navigate = useNavigate();

    return (
        <div className=" top-0 left-0 m-4">
            <a onClick={() => navigate(to)} className="text-lg font-semibold cursor-pointer wtext">
            ← NAZAJ
            </a>
        </div>
    );
};

export default BackButton;
